// BUYMED PREMIUM - Phase 1. Màu/gradient khai báo ở :root trong styles/globals.css.

// Đọc từ field `membershipType` của customer (API customer/me).
export enum ENUM_MEMBERSHIP_TYPE {
  NORMAL = 'NORMAL',
  PREMIUM = 'PREMIUM',
}

// Gói lạ (BE thêm gói mà FE chưa hỗ trợ) quy về NORMAL để không hiện sai quyền lợi.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMembershipType = (user: any): ENUM_MEMBERSHIP_TYPE => {
  const membershipType = user?.membershipType as ENUM_MEMBERSHIP_TYPE;
  return Object.values(ENUM_MEMBERSHIP_TYPE).includes(membershipType) ? membershipType : ENUM_MEMBERSHIP_TYPE.NORMAL;
};

const PREMIUM_PROGRAM_NAME = 'Buymed Premium';

// Tên gói do BE trả về trong `customer.membership`. Map này chỉ là fallback cho
// môi trường BE chưa deploy, gói mới không cần thêm vào đây.
export const MEMBERSHIP_FALLBACK: Record<ENUM_MEMBERSHIP_TYPE, { name: string; shortName: string }> = {
  [ENUM_MEMBERSHIP_TYPE.NORMAL]: { name: '', shortName: '' },
  [ENUM_MEMBERSHIP_TYPE.PREMIUM]: { name: PREMIUM_PROGRAM_NAME, shortName: 'Premium' },
};
